import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import ValidationAlert from '../../../app/components/ValidationAlert';

type DragNDropFileListProps = {
  files: Array<{
    id: string;
    name: string;
    size: number;
  }>;
  readOnly?: boolean;
  showSaveErrors: boolean;
  saveErrors: string[];
  formatFileSize: (bytes: number) => string;
  onOpenFile: (fileId: string, fileName: string) => void;
  onDownloadFile: (fileId: string, fileName: string) => void;
  onRemoveFile: (fileId: string) => void;
};

type FileActionButtonProps = {
  tooltip: string;
  title: string;
  className: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
};

const FileActionButton: React.FC<FileActionButtonProps> = props => (
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip>{props.tooltip}</Tooltip>}
  >
    <button
      type="button"
      onClick={props.onClick}
      className={props.className}
      title={props.title}
    >
      {props.children}
    </button>
  </OverlayTrigger>
);

const DragNDropFileList: React.FC<DragNDropFileListProps> = props => (
  <div className="file-list">
    <h3 className="file-list-title">
      {'Pliki'} ({props.files.length})
    </h3>
    {props.files.map(fileObj => (
      <div key={fileObj.id} className="file-item">
        <div className="file-details">
          <Icon.FileEarmark className="file-icon" />
          <div className="file-meta">
            <span className="file-name">{fileObj.name}</span>
            <span className="file-size">
              {props.formatFileSize(fileObj.size)}
            </span>
          </div>
        </div>
        <div className="file-actions">
          <FileActionButton
            tooltip="Podgląd pliku"
            title="Podgląd pliku"
            className="file-download-button"
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              props.onOpenFile(fileObj.id, fileObj.name);
            }}
          >
            <Icon.Eye />
          </FileActionButton>
          <FileActionButton
            tooltip="Pobierz plik"
            title="Pobierz plik"
            className="file-download-button"
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              props.onDownloadFile(fileObj.id, fileObj.name);
            }}
          >
            <Icon.Download />
          </FileActionButton>
          {!props.readOnly && (
            <FileActionButton
              tooltip="Usuń plik"
              title="Usuń plik"
              className="file-remove-button"
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                props.onRemoveFile(fileObj.id);
              }}
            >
              <Icon.X />
            </FileActionButton>
          )}
        </div>
      </div>
    ))}
    <ValidationAlert
      show={props.showSaveErrors}
      errors={props.saveErrors}
      className="m-3"
    />
  </div>
);

export default DragNDropFileList;
